import { render } from "./TeamManageRegistCount.vue?vue&type=template&id=ff28468a"
import script from "./TeamManageRegistCount.vue?vue&type=script&lang=js"
export * from "./TeamManageRegistCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__